import { render, staticRenderFns } from "./DeviceReplaceModal.vue?vue&type=template&id=52aabe00&scoped=true&"
import script from "./DeviceReplaceModal.vue?vue&type=script&lang=ts&"
export * from "./DeviceReplaceModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aabe00",
  null
  
)

export default component.exports